import {useParams} from 'react-router-dom'

import {Loader, Empty, BlackboardChartIcon} from 'common/components'
import {useGetForecast} from 'common/api'
import {ProjectForecastChart, ProjectForecastList} from '.'

export default function ProjectForecast() {
  const params = useParams()
  const {data: forecast} = useGetForecast(params.uuid)

  if (!forecast) return <Loader />

  if (!forecast.length)
    return <Empty icon={<BlackboardChartIcon />} title="forecast" />

  return (
    <div>
      <ProjectForecastChart />
      <ProjectForecastList />
    </div>
  )
}
